import { render, staticRenderFns } from "./UserGuide.vue?vue&type=template&id=a38e0556&scoped=true"
import script from "./UserGuide.vue?vue&type=script&lang=js"
export * from "./UserGuide.vue?vue&type=script&lang=js"
import style0 from "./UserGuide.vue?vue&type=style&index=0&id=a38e0556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38e0556",
  null
  
)

export default component.exports